module.exports = __webpack_public_path__ + "img/turbo2.4623adaa.jpg";